/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useState, useRef, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AnimatedList from '../../../../../components/Animation/AnimatedList';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import FormatDateString from '../../../../../CommonMethods/FromatDateString';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import { dataService } from '../../../../../services/data.services';
import GlobalContext from '../../../../../components/Context/GloablContext';

const TableBody = ({ tableData, indexNum }) => {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const selectedRef = useRef(null);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);

    useOnClickOutside(selectedRef, () => setSelectedIndex(null));

    const handelActionButton = (index) => {
        setSelectedIndex(index === selectedIndex ? null : index);
    };

    const handleDownload = async () => {
        try {
            setDownloadLoading(true);
            let endpoint = `invoice/details?_id=${tableData._id}&export=true`;
            const response = await dataService.GetAPI(endpoint);
            // Handle download response
            setToastmessage('Invoice downloaded successfully');
            window.open(response?.data?.data?.pre_signed_url);
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || 'Error downloading invoice');
            console.error('Error downloading invoice:', error);
        } finally {
            setDownloadLoading(false);
            setSelectedIndex(null);
        }
    };

    const handleStatus = (key) => {
        const val = {
            paid: { status: "Paid", img: "successDot.svg", color: "bg-[#C5FFD5]" },
            unpaid: { status: "Unpaid", img: "draft-img.svg", color: "bg-[#FFEEB0]" },
            "partially-paid": { status: "Partially Paid", img: "bluedot.svg", color: "bg-[#C2DCEF]" },
            default: { status: "Pending", img: "bluedot.svg", color: "bg-[#FEF9C3]" }
        };
        return (val[tableData.status] || val.default)[key];
    };

    const formatAmount = (amount) => {
        if (!amount || amount.toString() === "") return "-";
        return amount.toString().includes(".") ? amount.toString() : parseFloat(amount).toFixed(2);
    };

    return (
        <AnimatedList
            rowStatus={tableData.status}
            keyItem={indexNum}
            title="View Invoice Details"
            cursorpointer={true}
            handleClick={(e) => {
                if (e.target.classList.contains('prevent-click')) {
                    return;
                }
                navigate(`/student-master/invoice-list/invoices-details/${tableData._id}?${searchParams.toString()}`);
            }}
            child={
                <>
                    <td className="text-start">{FormatDateString(tableData?.date) || "-"}</td>
                    <td className="text-start" data-testid="student-name">
                        {tableData?.student_name || "-"} [{tableData?.student_id || "-"}]
                    </td>
                    <td className="text-start">
                        {tableData?.class_name || "-"}, {tableData?.section_name || "-"}
                    </td>
                    <td className="text-start" data-testid="invoice-number">
                        {tableData.invoice_number || "-"}
                    </td>
                    <td className="text-end">{formatAmount(tableData?.invoice_total)}</td>
                    <td className="text-end">{formatAmount(tableData?.rcvd_amount)}</td>
                    <td className="text-end">{formatAmount(tableData?.due_amount)}</td>
                    <td className="text-start">{tableData?.invoice_name || "-"}</td>
                    <td className="text-start">{tableData?.academic_year || "-"}</td>
                    <td className="table-cell">
                        <div className="flex justify-start">
                            <div className={`w-fit rounded ${handleStatus("color")} flex items-center justify-center py-1.5 px-2 2xl:px-2.5`}>
                                <img loading="lazy" decoding="async" src={`/images/${handleStatus("img")}`} alt="icon" />
                                <span className="text-f7 font-normal text-[#031624] pl-1">{handleStatus("status")}</span>
                            </div>
                        </div>
                    </td>
                    {<td className="prevent-click">
                        <div className="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                            <button
                                type="button"
                                className="list-more-btn prevent-click"
                                id={'3dot'+indexNum}
                                onClick={() => handelActionButton(indexNum)}
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"
                                data-te-ripple-init
                                data-te-ripple-color="light"
                            >
                                <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" className="prevent-click" />
                            </button>
                            {selectedIndex === indexNum && (
                                <ul
                                    ref={selectedRef}
                                    className={`${(indexNum+1 === 10 || indexNum+2 === 10) ? 'top3' : ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click`}
                                    aria-labelledby="dropdownMenuButton2"
                                    data-te-dropdown-menu-ref
                                >
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => {
                                                navigate(`/student-master/invoice-list/invoices-details/${tableData._id}?${searchParams.toString()}`);
                                                setSelectedIndex(null);
                                            }}
                                            buttonName="View Details"
                                            id="view_invoice"
                                            link={`/student-master/invoice-list/invoices-details/${tableData._id}?${searchParams.toString()}`}
                                            className="list-more-optns prevent-click"
                                        />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={handleDownload}
                                            buttonName="Download"
                                            id="download_invoice"
                                            className="list-more-optns prevent-click"
                                            loading={downloadLoading}
                                        />
                                    </li>
                                </ul>
                            )}
                        </div>
                    </td>}
                </>
            }
        />
    );
};

export default TableBody;
